import {createAction, props} from '@ngrx/store';
import { SharedNewsletter } from '.';

export const wsConnect = createAction(
  '[NEWSLETTER - WS] Connect'
);

export const wsConnectAndCheckNewsletter = createAction(
  '[NEWSLETTER - WS] Connect and check newsletter',
  props<{newsletterId: number}>()
);

export const wsConnected = createAction(
  '[NEWSLETTER - WS] Connected'
);

export const wsSetIsConnected = createAction(
  '[NEWSLETTER - WS] Set is connected'
);

export const wsDisconnect = createAction(
  '[NEWSLETTER - WS] Disconnect'
);

export const wsDisconnectIfConnected = createAction(
  '[NEWSLETTER - WS] Disconnect if connected'
);

export const wsDisconnected = createAction(
  '[NEWSLETTER - WS] Disconnected'
);

export const wsStartKeepAlive = createAction(
  '[NEWSLETTER - WS] Start keep alive!'
);

export const wsStopKeepAlive = createAction(
  '[NEWSLETTER - WS] Stop keep alive!'
);

// FROM CLIENT

export const wsUpdateNewsletters = createAction(
  '[NEWSLETTER - WS] Init User'
);

export const wsUpdateNewslettersWithNewsletterId = createAction(
  '[NEWSLETTER - WS] Init User with Newsletter Id',
  props<{newsletterId: number}>()
);

export const wsStartWork = createAction(
  '[NEWSLETTER - WS] Start work',
  props<{newsletterId: number}>()
);

export const wsStopWork = createAction(
  '[NEWSLETTER - WS] Stop work',
  props<{newsletterId: number}>()
);

export const wsCheckNewsletter = createAction(
  '[NEWSLETTER - WS] Check newsletter',
  props<{newsletterId: number}>()
);

export const wsNewsletterDeleted = createAction(
  '[NEWSLETTER - WS] Newsletter deleted',
  props<{newsletterId: number}>()
);

export const wsMovedToDraft = createAction(
  '[NEWSLETTER - WS] Newsletter moved to drafts',
  props<{newsletterId: number}>()
);

export const wsUnshare = createAction(
  '[NEWSLETTER - WS] Newsletter unshare',
  props<{newsletterId: number}>()
);

// TO CLIENT
export const wsMessageReceived = createAction(
  '[NEWSLETTER - WS] Message received',
  props<{messageType: string, data: any, singleNewsletter: boolean}>()
);

export const wsNewsletterInfo = createAction(
  '[NEWSLETTER - WS] Newsletter info message',
  props<({ newsletters: Array<SharedNewsletter>, singleNewsletter: boolean})>()
);

export const wsNewsletterTaken = createAction(
  '[NEWSLETTER - WS] Newsletter taken message',
  props<({ newsletter: SharedNewsletter, singleNewsletter: boolean})>()
);

export const wsNewsletterReleased = createAction(
  '[NEWSLETTER - WS] Newsletter released message',
  props<({ newsletter: SharedNewsletter, singleNewsletter: boolean})>()
);

export const wsNewsletterAccessDenied = createAction(
  '[NEWSLETTER - WS] Newsletter access denied message',
  props<({ newsletterId: number, singleNewsletter: boolean})>()
);

export const wsNewsletterAccessGranted = createAction(
  '[NEWSLETTER - WS] Newsletter access granted message',
  props<({ newsletterId: number, singleNewsletter: boolean})>()
);

export const wsUpdateRequired = createAction(
  '[NEWSLETTER - WS] Newsletter update required'
);

export const wsUnknownMessage = createAction(
  '[NEWSLETTER - WS] Newsletter unknown message',
  props<({messageType: string, data: any, singleNewsletter: boolean})>()
);
